import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from 'react';
import { apis, apiHolder } from 'api';
import { TempContactActions, ContactActions, useActions, useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import { WriteContext } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
import SelectList from '@web-common/components/UI/SiriusContact/selectList';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import { doGetContactModelByContactItem } from '@web-common/state/selector/contact';
import { StaticRootNodeKey } from '@web-common/utils/contact_util';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import debounce from 'lodash/debounce';
import { getIn18Text } from 'api';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = apiHolder.api.getSystemApi();
const WriteContact = props => {
    const { showSearch } = props;
    const { isMailTemplate } = useContext(WriteContext);
    const [searchValue, setSearchValue] = useState('');
    const onContactActions = isMailTemplate ? TempContactActions : ContactActions;
    const { doAddItemToSelector, doFocusSelector } = useActions(onContactActions);
    const { focused } = useAppSelector(state => state.contactReducer.selector);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const dispatch = useAppDispatch();
    const currentMailCid = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid, [currentMail]);
    const shouldShowOrgContact = !isCorpMail;
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const focusedRef = useRef(focused);
    useEffect(() => {
        focusedRef.current = focused;
    }, [focused]);
    const handleSelect = async (itemList) => {
        var _a;
        const focusType = focusedRef.current || 'to';
        if (!((_a = ['to', 'bcc', 'cc']) === null || _a === void 0 ? void 0 : _a.includes(focusType))) {
            doFocusSelector('to');
        }
        const list = await doGetContactModelByContactItem(itemList, {
            useCompositeQuery4Lx: true,
        });
        doAddItemToSelector({
            add: true,
            pendingItem: list,
        });
    };
    const onExpand = (type, isOpen) => {
        if (type === 'personalOrg') {
            trackApi.track('pcMail_click_allContacts_personalAddress_writeMailPage', {
                status: isOpen ? getIn18Text('ZHANKAI') : getIn18Text('SHOUQI'),
            });
        }
        else if (type === 'org') {
            trackApi.track('pcMail_click_department_enterpriseAddress_writeMailPage', {
                status: isOpen ? getIn18Text('ZHANKAI') : getIn18Text('SHOUQI'),
            });
        }
        else if (type === 'team') {
            trackApi.track('pcMail_click_department_groupAddress_writeMailPage', {
                status: isOpen ? getIn18Text('ZHANKAI') : getIn18Text('SHOUQI'),
            });
        }
    };
    const onSearchChange = (value) => {
        dispatch(mailActions.doChangeMailInfoStatus(Object.assign(Object.assign({}, currentMail.status), { keyword: value })));
    };
    const debounceSearch = useCallback(debounce(value => {
        onSearchChange(value);
    }, 700), [onSearchChange]);
    useEffect(() => {
        const { status } = currentMail;
        let searchKeyword = '';
        if (!status) {
            searchKeyword = '';
        }
        else {
            const { keyword } = status;
            searchKeyword = keyword;
        }
        setSearchValue(searchKeyword);
    }, [currentMailCid]);
    const defualtType = useMemo(() => {
        if (process.env.BUILD_ISEDM || navigateVersion) {
            return ['personal', 'enterprise', 'team', 'recent'];
        }
        return ['personal', 'enterprise', 'team', 'recent'];
    }, [navigateVersion]);
    return useMemo(() => {
        return (React.createElement(ErrorBoundary, { name: "writeContact" },
            React.createElement("div", { style: { height: '100%', paddingTop: '16px', minWidth: 300 } },
                React.createElement(SelectList, { containerHeight: "100%", shouldShowOrgContact: shouldShowOrgContact, showAddTeamBtn: true, showAddOrgBtn: true, showSeparator: true, showAddPersonalBtn: true, showNoDataPlaceholder: true, showMailListEye: true, useContactId: false, type: defualtType, order: ['customer', 'recent', 'personal', 'enterprise', 'team'], defaultExpandedKeys: [StaticRootNodeKey.ENTERPRISE, StaticRootNodeKey.PERSON], isIM: false, showCheckbox: false, multiple: false, onExpand: onExpand, onSelect: handleSelect, defaultSearchVal: searchValue, useEdm: process.env.BUILD_ISEDM || navigateVersion, isCustomerFirst: process.env.BUILD_ISEDM || navigateVersion, searchListProps: { showAvatar: false }, useMultiAccount: true, onInputChange: debounceSearch, flattenPersonalEmails: true, deduplicationByEmail: false, showSearch: showSearch }))));
    }, [searchValue, defualtType]);
};
export default WriteContact;
